/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { OrganisationSettings } from "./OrganisationSettings";
import {
  OrganisationSettingsFromJSON,
  OrganisationSettingsFromJSONTyped,
  OrganisationSettingsToJSON,
  OrganisationSettingsToJSONTyped,
} from "./OrganisationSettings";

/**
 *
 * @export
 * @interface PatchedOrganisation
 */
export interface PatchedOrganisation {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  uniqueId?: string;
  /**
   *
   */
  name?: string;
  /**
   *
   */
  settings?: OrganisationSettings;
  /**
   *
   */
  readonly ranaTenantId?: string | null;
}

/**
 * Check if a given object implements the PatchedOrganisation interface.
 */
export function instanceOfPatchedOrganisation(value: object): value is PatchedOrganisation {
  return true;
}

export function PatchedOrganisationFromJSON(json: any): PatchedOrganisation {
  return PatchedOrganisationFromJSONTyped(json, false);
}

export function PatchedOrganisationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedOrganisation {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    uniqueId: json["unique_id"] == null ? undefined : json["unique_id"],
    name: json["name"] == null ? undefined : json["name"],
    settings: json["settings"] == null ? undefined : OrganisationSettingsFromJSON(json["settings"]),
    ranaTenantId:
      json["rana_tenant_id"] === undefined
        ? undefined
        : json["rana_tenant_id"] === null
        ? null
        : json["rana_tenant_id"],
  };
}

export function PatchedOrganisationToJSON(json: any): PatchedOrganisation {
  return PatchedOrganisationToJSONTyped(json, false);
}

export function PatchedOrganisationToJSONTyped(
  value?: Omit<PatchedOrganisation, "url" | "ranaTenantId"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    unique_id: value["uniqueId"],
    name: value["name"],
    settings: OrganisationSettingsToJSON(value["settings"]),
  };
}
